export const exportarAExcel = ({
    datosAExportar,
    estatusBorrado,
    formatearFechaLarga,
    showSuccessToast,
    showErrorToast
}) => {
    try {
        if (!datosAExportar || datosAExportar.length === 0) {
            if (showErrorToast) showErrorToast('No hay datos disponibles para exportar.');
            return;
        }

        let htmlContent = `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="utf-8" />
<style>
    table { border-collapse: collapse; font-family: Arial, sans-serif; }
    th { background-color: #2c3e50; color: #ffffff; font-weight: bold; border: 1px solid #bdc3c7; text-align: center; padding: 8px; font-size: 14px; }
    td { border: 1px solid #bdc3c7; padding: 8px; font-size: 13px; text-align: left; }
    .text-center { text-align: center; }
    .row-even { background-color: #ecf0f1; }
    .row-odd { background-color: #ffffff; }
    .badge-nube { color: #2980b9; font-weight: bold; }
    .badge-pos { color: #8e44ad; font-weight: bold; }
    .danger-text { color: #c0392b; font-weight: bold; }
</style>
</head>
<body>
    <table>
        <thead>
            <tr>
                <th>UUID Empresa</th>
                <th>Nombre Empresa</th>
                <th>Tipo Licencia</th>
                <th>Días Vencidos</th>
                <th>Fecha Vencimiento</th>
                <th>Servidor</th>
                <th>Base de Datos</th>
                <th>${estatusBorrado === 1 ? 'Fecha en que se agregó' : 'Últ. Conexión Nube'}</th>
                ${estatusBorrado === 1 ? '' : '<th>Últ. Conexión AkasiaPOS</th>'}
            </tr>
        </thead>
        <tbody>`;

        datosAExportar.forEach((row, index) => {
            const bgClass = index % 2 === 0 ? 'row-even' : 'row-odd';
            const tipoClass = row.vTipoLicencia === 'Nube' ? 'badge-nube' : (row.vTipoLicencia === 'AkasiaPOS' ? 'badge-pos' : '');

            const fechaVencimiento = formatearFechaLarga(row.dFechaVencimiento);
            const fechaExtra = estatusBorrado === 1
                ? formatearFechaLarga(row.dFechaProgramacion)
                : formatearFechaLarga(row.dUltimaConexionNube);
            const fechaAkasiaPOS = formatearFechaLarga(row.dUltimaConexionAkasiaPOS);

            htmlContent += `
        <tr class="${bgClass}">
            <td style="mso-number-format:'@';">${row.vUUIDEmpresa || ''}</td>
            <td>${(row.vNombreEmpresa || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</td>
            <td class="${tipoClass} text-center">${row.vTipoLicencia || ''}</td>
            <td class="text-center danger-text">${row.iDiasVencidos || 0}</td>
            <td class="text-center">${fechaVencimiento}</td>
            <td>${row.vServer || ''}</td>
            <td>${row.vDatabase || ''}</td>
            <td class="text-center">${fechaExtra}</td>
            ${estatusBorrado === 1 ? '' : `<td class="text-center">${fechaAkasiaPOS}</td>`}
        </tr>`;
        });

        htmlContent += `
        </tbody>
    </table>
</body>
</html>`;

        const blob = new Blob([htmlContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `Empresas_${estatusBorrado === 1 ? 'Programadas' : 'Candidatas'}_Borrado_${new Date().getTime()}.xls`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        if (showSuccessToast) showSuccessToast('Archivo exportado a Excel correctamente.');
    } catch (error) {
        if (showErrorToast) showErrorToast(`Error al exportar a Excel: ${error.message}`);
    }
};
